import { FC } from "react";
import { Trans, useTranslation } from "react-i18next";
import { PiWarning } from "react-icons/pi";
import { useSelector } from "react-redux";
import { Modal } from "reactstrap";

import { IdleWarningModalProps } from "@models/components/kiosk.model";
import { RootState } from "@store/index";

const IdleWarningModal: FC<IdleWarningModalProps> = ({
  isOpen,
  onContinue,
  remainingTime,
}) => {
  const { t } = useTranslation();

  const isAuthenticated = useSelector(
    (State: RootState) => State.local.isAuthenticated
  );

  return (
    <Modal
      isOpen={isOpen}
      centered
      backdrop="static"
      backdropClassName="fg-idle-warning-backdrop"
      keyboard={false}
      className="idle-warning-modal"
      zIndex={1080}
    >
      <div className="modal-body text-center p-5">
        <div className="mb-4">
          <div className="idle-warning-icon mb-3">
            <PiWarning size={64} className="text-warning" />
          </div>
          <h3 className="fw-bold mb-3">
            {isAuthenticated
              ? t("kiosk.idleWarning.title")
              : t("kiosk.idleWarning.inactiveTitle")}
          </h3>
          <p className="text-muted mb-4">
            <Trans
              i18nKey={
                isAuthenticated
                  ? "kiosk.idleWarning.message"
                  : "kiosk.idleWarning.inactiveMessage"
              }
              values={{ seconds: remainingTime }}
              components={{
                bold: <span className="fw-bold text-danger fs-4" />,
              }}
            />
          </p>
          <p className="text-muted small">{t("kiosk.idleWarning.touchHint")}</p>
        </div>

        <button
          onClick={onContinue}
          className="btn btn-primary btn-lg px-5 py-3 fw-bold"
        >
          {isAuthenticated
            ? t("kiosk.idleWarning.continueButton")
            : t("kiosk.idleWarning.stayButton")}
        </button>
      </div>
    </Modal>
  );
};

export default IdleWarningModal;
